import Login from 'views/businessProfile/Login';
import PersonalInfo from 'views/businessProfile/PersonalInfo';
import Profile from 'views/businessProfile/Profile';
import SocialInfo from 'views/businessProfile/SocialInfo';

const getRoutes = () => {
    const routes = [
        {
            path: '/login',
            name: 'Login',
            component: Login,
            layout: '/business-profile',
            subRoute: false,
        },
        {
            path: '/view/:id',
            name: 'Business Profile',
            component: Profile,
            layout: '/business-profile',
            subRoute: false,
        },
        {
            path: '/profile',
            name: 'Profile',
            component: Profile,
            layout: '/business-profile',
            subRoute: false,
        },
        {
            path: '/personal-info',
            name: 'Personal Info',
            component: PersonalInfo,
            layout: '/business-profile',
            subRoute: false,
        },
        {
            path: '/socials',
            name: 'Socials',
            component: SocialInfo,
            layout: '/business-profile',
            subRoute: false,
        },
    ];

    const routesFr = [
        {
            path: '/login',
            name: 'Connexion',
            component: Login,
            layout: '/business-profile',
            subRoute: false,
        },
        {
            path: '/profil',
            name: 'Profil',
            component: Profile,
            layout: '/business-profile',
            subRoute: false,
        },
        {
            path: '/informations-personnelles',
            name: 'Informations personnelles',
            component: PersonalInfo,
            layout: '/business-profile',
            subRoute: false,
        },
        {
            path: '/réseaux sociaux',
            name: 'Réseaux sociaux',
            component: SocialInfo,
            layout: '/business-profile',
            subRoute: false,
        },
    ];

    const language = window.localStorage.i18nextLng;

    if (language?.includes('fr')) {
        return routesFr;
    } else return routes;
};
export default getRoutes;
